<div class="contenedor-tabla">
    <mat-table
        class="oocc-tabla"
        #table
        [dataSource]="dataSource"
        matSort
        matSortActive="numero"
        matSortDisableClear
        matSortDirection="desc"
        [@animateStagger]="{ value: '50' }"
        fusePerfectScrollbar
    >
        <ng-container matColumnDef="select">
            <mat-header-cell *matHeaderCellDef> </mat-header-cell>
            <mat-cell *matCellDef="let oc">
                <div
                    [hidden]="
                        !_menuUsuarioSrvc.esSupervisor() || oc.factura?.numero
                    "
                >
                    <mat-checkbox
                        *ngIf="esSupervisor"
                        (click)="$event.stopPropagation()"
                        (change)="toggleSelect($event, oc)"
                        [checked]="
                            !_menuUsuarioSrvc.esSupervisor() ||
                            oc.factura?.numero
                                ? selection.isSelected(oc)
                                : false
                        "
                        [aria-label]="checkboxLabel(oc)"
                    >
                    </mat-checkbox>
                </div>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="numero">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                >OOCC</mat-header-cell
            >
            <mat-cell *matCellDef="let oc">
                <a [routerLink]="'/ordenes-de-compra/' + oc.id">
                    <strong>{{ oc.numero }} </strong>
                </a>
                <!-- <span *ngIf="_menuUsuarioSrvc.esEncargado()"
                    ><strong>{{ oc.numero }} </strong></span
                >-->
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="documento">
            <mat-header-cell *matHeaderCellDef>Informe</mat-header-cell>
            <mat-cell *matCellDef="let oc">
                <button
                    *ngIf="oc.tieneInforme == true"
                    mat-icon-button
                    type="button"
                    color="accent"
                    (click)="bajarInforme(oc.id)"
                >
                    <mat-icon>cloud_download</mat-icon>
                </button>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fecha">
            <mat-header-cell *matHeaderCellDef mat-sort-header
                >Fecha</mat-header-cell
            >
            <mat-cell *matCellDef="let oc">
                <p>
                    {{ oc.fecha | date: "dd-MM-YYYY" }}
                </p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="nombre">
            <mat-header-cell *matHeaderCellDef class="column-nombre"
                >Cliente</mat-header-cell
            >
            <mat-cell *matCellDef="let oc" class="column-nombre">
                <p>
                    <strong>{{ oc.cliente.nombre }}</strong>
                </p>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="nrrut">
            <mat-header-cell *matHeaderCellDef class="column-rut"
                >Rut</mat-header-cell
            >
            <mat-cell *matCellDef="let oc" class="column-rut">
                <p>
                    {{ oc.cliente.rut }}
                </p>
            </mat-cell>
        </ng-container>

        <mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>
        <mat-row *matRowDef="let oc; columns: displayedColumns"></mat-row>
    </mat-table>
    <mat-paginator
        #paginator
        [length]="resultsLength"
        [pageIndex]="0"
        [pageSize]="10"
        [pageSizeOptions]="[5, 10, 25, 100]"
    >
    </mat-paginator>
</div>
<div
    fxLayout="row"
    fxLayoutAlign.lt-md="center center"
    fxLayoutAlign="end end"
    fxLayoutGap="10px"
>
    <button
        *ngIf="(oocc.length > 0 && esRepresentante) || esSupervisor"
        mat-raised-button
        color="accent"
        class="mt-16"
        (click)="abrirConsultaReporte()"
    >
        Bajar Reporte
    </button>

    <button
        *ngIf="esSupervisor"
        mat-raised-button
        color="accent"
        class="mt-16"
        [disabled]="selection.isEmpty() || !ooccMismoCliente"
        (click)="asociarFactura()"
    >
        Asociar Factura
    </button>
</div>

<!-- /div -->
